import UserLayout from "../utils/user/UserLayout";
import React, { useEffect, useState } from "react";
import DonutChart from "../utils/graphs/DonutChart";
import { connect } from "react-redux";
import { fetchAnalyticsAction } from "../../redux/actions/analytics/analyticsAction";

export const Analytics = (props) => {

    const [profile, setProfile] = useState({
        value: 0,
        text: "",
        bgcolor: "#d3eaf3",
        type: "%",
        isDisplayVal: true,
    });
    const [network, setNetwork] = useState({
        value: 10,
        text: "weak",
        bgcolor: "#d3eaf3",
        type: "",
        isDisplayVal: false,
    });
    const [score, setScore] = useState({
        value: 0,
        text: "",
        bgcolor: "#d3eaf3",
        type: "",
        isDisplayVal: true,
    });
    const [performance, setPerformance] = useState({
        value: 0,
        text: "",
        bgcolor: "#d3eaf3",
        type: "",
        isDisplayVal: false,
    });

    useEffect(() => {
        if (Object.keys(props.profile).length > 0) {
            setProfile((prevState) => ({
                ...prevState,
                value: props.profile.profile_fill,
            }));
            setScore((prevState) => ({
                ...prevState,
                value: props.profile.my_score,
            }));
        }

        if (Object.keys(props.analytics).length === 0) {
            props.fetchAnalytics()
        }

        if (Object.keys(props.analytics).length > 0) {
            setNetwork((prevState) => ({
                ...prevState,
                value: props.analytics.network_score,
                text: props.analytics.network_status,
            }));
            setPerformance((prevState) => ({
                ...prevState,
                value: props.analytics.performance_score,
            }));
        }
    }, [props]);


    return (
        <UserLayout>
            <div className="right-section">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="inner-content primary-content">
                            <h2 className="page-title">
                                <strong>MY</strong>
                                <br></br>analytics
                            </h2>
                            <p>
                                Intro to the my analytics section required. Intro to the my
                                analytics section required. Intro to the my analytics section
                                required. Intro to the my analytics section required. Intro to
                                the my analytics section required. Intro to the my analytics
                                section required.{" "}
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-6 col-12">
                        <div className="row">
                            <div className="col-md-6 col-12 cbr cbb pl-0">
                                <div className="graph-wrap pr-15">
                                    <div className="graph-item">
                                        <div
                                            id="networkGraph"
                                            className="custom-circle-progress label-center"
                                        >
                                            <DonutChart data={score} />
                                        </div>
                                    </div>
                                    <div className="graph-footer">
                                        <div className="graph-title">
                                            <strong>MY</strong> score
                                        </div>
                                        <div className="graph-icon">
                                            <img
                                                src="/assets/images/icons/my_profile_without-hexagon.svg"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 cbb pr-0">
                                <div className="graph-wrap pl-15">
                                    <div className="graph-item">
                                        <div
                                            id="networkGraph"
                                            className="custom-circle-progress label-center"
                                        >
                                            <DonutChart data={profile} />
                                        </div>
                                    </div>
                                    <div className="graph-footer">
                                        <div className="graph-title">
                                            <strong>MY</strong> profile
                                        </div>
                                        <div className="graph-icon">
                                            <img
                                                src="/assets/images/goals-icons/references.svg"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 cbr pl-0">
                                <div className="graph-wrap pr-15">
                                    <div className="graph-item">
                                        <div
                                            id="referenceGraph"
                                            className="custom-circle-progress label-center"
                                        >
                                            <DonutChart data={network} />
                                        </div>
                                    </div>
                                    <div className="graph-footer">
                                        <div className="graph-title">
                                            <strong>MY</strong> network
                                        </div>
                                        <div className="graph-icon">
                                            <img
                                                src="/assets/images/icons/my_Network_without_hexagon.svg"

                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 pr-0">
                                <div className="graph-wrap pl-15">
                                    <div className="graph-item">
                                        <div
                                            id="performanceGraph"
                                            className="custom-circle-progress label-center"
                                        >
                                            <DonutChart data={performance} />
                                        </div>
                                    </div>
                                    <div className="graph-footer">
                                        <div className="graph-title">
                                            <strong>MY</strong> performance
                                        </div>
                                        <div className="graph-icon">
                                            <img
                                                src="/assets/images/icons/my_performancewithout--hexagon.svg"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </UserLayout>
    );
};

const mapStateToProps = (state) => {
    const user = state.user.user;
    const analytics = state.analytics.analytics;
    const profile = state.user.profile;

    return {
        user: user,
        analytics: analytics,
        profile: profile,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        fetchAnalytics: () => dispatch(fetchAnalyticsAction()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);
